namespace TabAurous.OMS {
    export interface DiscountingPolicyDetailsForm {
        DiscountType: Serenity.EnumEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: CommonCategoryLookup;
        SubCategoryId: CommonSubCategoryLookup;
        ProcessId: Serenity.LookupEditor;
        Priority: Serenity.IntegerEditor;
        MaxDiscountPercent: Serenity.DecimalEditor;
    }

    export class DiscountingPolicyDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.DiscountingPolicyDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DiscountingPolicyDetailsForm.init)  {
                DiscountingPolicyDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.LookupEditor;
                var w2 = CommonCategoryLookup;
                var w3 = CommonSubCategoryLookup;
                var w4 = s.IntegerEditor;
                var w5 = s.DecimalEditor;

                Q.initFormType(DiscountingPolicyDetailsForm, [
                    'DiscountType', w0,
                    'ProductTypeId', w1,
                    'CategoryId', w2,
                    'SubCategoryId', w3,
                    'ProcessId', w1,
                    'Priority', w4,
                    'MaxDiscountPercent', w5
                ]);
            }
        }
    }
}
